import { render, staticRenderFns } from "./Realtime.vue?vue&type=template&id=17c09760&scoped=true&"
import script from "./Realtime.vue?vue&type=script&lang=js&"
export * from "./Realtime.vue?vue&type=script&lang=js&"
import style0 from "./Realtime.vue?vue&type=style&index=0&id=17c09760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c09760",
  null
  
)

export default component.exports